import * as React from 'react';
import { Modal, Button } from 'react-bootstrap';

class GetDeveloperModal extends React.Component<any, any> {
  constructor(props) {
    super(props);
    // eslint-disable-next-line react/state-in-constructor
    this.state = {
      process_id: 0,
      show: false,

      defaultValue: '',
      value: '',
      error: null,
    };
  }

  // eslint-disable-next-line react/sort-comp
  public show(process_id: number, owner_email?: string) {
    this.setState({
      process_id,
      show: true,
      defaultValue: owner_email ?? '',
      value: owner_email ?? '',
    });
  }

  handleClose = () => {
    this.setState({
      process_id: 0,
      show: false,
      defaultValue: '',
      value: '',
      error: null,
    });
  };

  // TODO возможно, придется убрать по результатам EPGU 262, 266, 268
  // eslint-disable-next-line consistent-return
  handleChange = () => {
    const { process_id, value, defaultValue } = this.state;
    const { api } = this.props;

    if (!value || value === defaultValue) {
      this.handleClose();
      return false;
    }

    api.changeDeveloper(process_id, value, {
      success: () => {
        this.handleClose();
      },
    });
  };

  // eslint-disable-next-line consistent-return
  handleCreate = () => {
    const { process_id, value, defaultValue } = this.state;
    const { func } = this.props;

    if (!value || value === defaultValue) {
      this.handleClose();
      return false;
    }

    this.handleClose();
    func(process_id, value);
  };

  handlerChangeInput = (e) => {
    this.setState({
      value: e.target.value,
      error: this.validateInput(e.target.value),
    });
  };

  validateInput = (value) => {
    const emailRegex =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!value.match(emailRegex)) {
      return 'Не правильный email';
    }
    return null;
  };

  render() {
    const { value } = this.state;

    return (
      // @ts-ignore
      <Modal
        show={this.state.show}
        className="inviteDeveloperModal"
        onHide={this.handleClose}
        // TODO: What is this?
        // style={{
        // 	overlay: {
        // 		backgroundColor: "rgba(0,0,0,.25)",
        // 	},
        // }}
      >
        {/*// @ts-ignore*/}
        <Modal.Header closeButton>
          {/*// @ts-ignore*/}
          <Modal.Title>Запросить ТКП</Modal.Title>
        </Modal.Header>
        {/*// @ts-ignore*/}
        <Modal.Body>
          <div className="form-group">
            <label>Введите e-mail компании разработчика</label>
            <input
              onChange={this.handlerChangeInput}
              type="email"
              name="email"
              id="email"
              className="form-control"
              value={value}
            />
            {this.state.error ? (
              <div className="alert alert-danger" role="alert">
                {this.state.error}
              </div>
            ) : null}
          </div>
        </Modal.Body>
        {/*// @ts-ignore*/}
        <Modal.Footer>
          {/*// @ts-ignore*/}
          <Button onClick={this.handleClose}>Закрыть</Button>
          {/*// @ts-ignore*/}
          <Button
            onClick={
              this.state.defaultValue ? this.handleChange : this.handleCreate
            }
            bsStyle="primary"
            disabled={!!this.state.error}
          >
            Запросить
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default GetDeveloperModal;
